import { render } from "./LoginBaseTemplate.vue?vue&type=template&id=2509c159"
import script from "./LoginBaseTemplate.vue?vue&type=script&lang=js"
export * from "./LoginBaseTemplate.vue?vue&type=script&lang=js"

import "./LoginBaseTemplate.vue?vue&type=style&index=0&id=2509c159&lang=scss"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__